import React, { useState } from 'react'
import { Spinner } from 'msp-components'
import OrderReturnAction from '@/pages/account/AccountOrders/AccountOrderDetail/OrderActions/OrderReturnAction/OrderReturnAction'
import OrderReorderAction from '@/pages/account/AccountOrders/AccountOrderDetail/OrderActions/OrderReorderAction/OrderReorderAction'
import OrderCancellationAction from '@/pages/account/AccountOrders/AccountOrderDetail/OrderActions/OrderCancellationAction/OrderCancellationAction'
import { OrderActionProps } from './OrderActions.types'
import * as S from './OrderActions.styles'

const OrderActions = ({
  order,
  setIsCancelled,
  setAlertBoxMessage,
  setIsError
}: OrderActionProps) => {
  const [isProcessing, setIsProcessing] = useState(false)

  return (
    <div className={S.Wrapper}>
      {isProcessing && <Spinner fullScreen />}
      <OrderReorderAction
        order={order}
        isProcessing={isProcessing}
        setIsProcessing={setIsProcessing}
      />
      {order.isCancellable() && (
        <OrderCancellationAction
          order={order}
          isProcessing={isProcessing}
          setIsProcessing={setIsProcessing}
          setIsCancelled={setIsCancelled}
          setAlertBoxMessage={setAlertBoxMessage}
          setIsError={setIsError}
        />
      )}
      {order.isReturnable() && <OrderReturnAction order={order} />}
    </div>
  )
}

export default OrderActions
